<template>
    <button
        :class="classList"
        :type="buttonConfig.type"
        :href="buttonConfig.href"
        :tabindex="buttonConfig.tabIndex || 0"
        :aria-disabled="isDisabled"
        v-on:keyup.tab="tabFocus = true"
        @click="$emit('click', $event)"
        @blur="tabFocus = false"
    >
        <span class="button__text">
            {{ displayText }}
        </span>
    </button>
</template>

<script>
    import { ButtonState, default as ButtonConfig } from 'models/ButtonConfig';

    export default {
        name: 'FormButton',
        props: {
            buttonConfig: {
                type: Object,
                required: true,
                default: new ButtonConfig()
            },
            buttonState: {
                type: String,
                required: false,
                default: ButtonState.Enabled
            }
        },

        data: function () {
            return {
                tabFocus: false
            };
        },

        computed: {
            isDisabled() {
                return this.buttonState === ButtonState.Disabled;
            },
            classList() {
                let list;
                let { styleClass, qaClass } = this.buttonConfig;

                if (styleClass) {
                    list = [styleClass, qaClass];
                } else {
                    list = ['button'];
                }

                if (this.buttonState === ButtonState.Disabled) {
                    list.push('disabled');
                } else if (this.buttonState === ButtonState.Loading) {
                    list.push('loading');
                }

                if (this.tabFocus) {
                    list.push('focus');
                }

                return list;
            },

            displayText() {
                let displayTexts = this.buttonConfig.displayTexts;

                if (!displayTexts) {
                    return this.buttonConfig.displayText;
                }

                if (this.buttonState === ButtonState.Disabled) {
                    return displayTexts[ButtonState.Disabled] || displayTexts[ButtonState.Enabled];
                } else if (this.buttonState === ButtonState.Loading) {
                    return displayTexts[ButtonState.Loading] || displayTexts[ButtonState.Enabled];
                } else {
                    return displayTexts[ButtonState.Enabled];
                }
            }
        }
    };
</script>
